"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MockedTokenProvider = void 0;
/** @deprecated Please import from @ori/auth/mocked */ var MockedTokenProvider = function(param) {
    var children = param.children;
    return children;
};
exports.MockedTokenProvider = MockedTokenProvider; //# sourceMappingURL=MockedTokenProvider.js.map
